module.exports = __webpack_public_path__ + "static/media/avatar.ddd8f3fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.jpg
// module id = 28
// module chunks = 0